import {
  isEmpty,
  isDate,
  isNumber,
  isArray,
  isString,
  upperFirst,
  toLower
} from 'lodash'
import moment from 'moment'
import Vue from 'vue';
export const EventBus = new Vue();

export const MOMENT_FORMAT_DATE = 'YYYY-MM-DD'
export const MOMENT_FORMAT_DATE_TIME = 'YYYY-MM-DD HH:mm:ss'

export const NOT_REQUESTED = 'NOT_REQUESTED'
export const REQUEST_PENDING = 'REQUEST_PENDING'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_ERROR = 'REQUEST_ERROR'
export const GQL_DATE_FORMAT = 'ddd MMM D YYYY HH:mm:ss'
export const TIME_FORMAT = 'hh:mm A'
export const API_STATES = {
  NOT_REQUESTED,
  REQUEST_PENDING,
  REQUEST_SUCCESS,
  REQUEST_ERROR
}

export const US_CELL_CARRIERS = [
  { value : '@paging.acswireless.com'   ,text : 'ACS Wireless' },
  { value : '@txt.att.net'              ,text : 'AT&T' },
  { value : '@advantagepaging.com'      ,text : 'Advantage Communications' },
  { value : '@airtouch.net'             ,text : 'Airtouch Pagers - @airtouch.net' },
  { value : '@airtouchpaging.com'       ,text : 'Airtouch Pagers - @airtouchpaging.com' },
  { value : '@alphapage.airtouch.com'   ,text : 'Airtouch Pagers - @alphapage.airtouch.com'}, //eslint-disable-line
  { value : '@myairmail.com'            ,text : 'Airtouch Pagers - @myairmail.com' },
  { value : '@message.alltel.com'       ,text : 'Alltel - @message.alltel.com' },
  { value : '@alphanow.net'             ,text : 'AlphNow' },
  { value : '@clearpath.acswireless.com',text : 'Ameritech Clearpath' },
  { value : '@pageapi.com'              ,text : 'Ameritech Paging - @pageapi.com' },
  { value : '@epage.arch.com'           ,text : 'Arch Pagers (PageNet)' },
  { value : '@bplmobile.com'            ,text : 'BPL mobile' },
  { value : '@sms.beemail.ru'           ,text : 'BeeLine GSM' },
  { value : '@message.bam.com'          ,text : 'Bell Atlantic' },
  { value : '@bellmobility.ca'          ,text : 'Bell Canada' },
  { value : '@txt.bellmobility.ca'      ,text : 'Bell Canada - @txt.bellmobility.ca' },
  { value : '@bellsouthtips.com'        ,text : 'Bell South (Blackberry)' },
  { value : '@blsdcs.net'               ,text : 'Bell South Mobility' },
  { value : '@bellsouth.cl'             ,text : 'Bell South - @bellsouth.cl' },
  { value : '@sms.bellsouth.com'        ,text : 'Bell South - @sms.bellsouth.co' },
  { value : '@wireless.bellsouth.com'   ,text : 'Bell South - @wireless.bellsouth.com' },
  { value : '@sms.bluecell.com'         ,text : 'Bluegrass Cellular' },
  { value : '@sms.myboostmobile.com'        ,text : 'Boost Mobile' },
  { value : '@phone.cellone.net'        ,text : 'Cellular One East Coast' },
  { value : '@paging.cellone-sf.com'    ,text : 'Cellular One PCS - @paging.cellone-sf.com'}, //eslint-disable-line
  { value : '@swmsg.com'                ,text : 'Cellular One South West - @swmsg.com' },
  { value : '@mobile.celloneusa.com'    ,text : 'Cellular One - @mobile.celloneusa.com' },
  { value : '@messaging.centurytel.net' ,text : 'CenturyTel - @messaging.centurytel.net'}, //eslint-disable-line
  { value : '@gocbw.com'                ,text : 'Cincinnati Bell' },
  { value : '@mobile.mycingular.com'    ,text : 'Cingular Wireless' },
  { value : '@comcastpcs.textmsg.com'   ,text : 'Comcast' },
  { value : '@sms.mycricket.com'        ,text : 'Cricket' },
  { value : '@mms.gci.net'              ,text : 'GCI' },
  { value : '.iws@iwspcs.net'           ,text : 'I Wireless' },
  { value : '@mci.com'                  ,text : 'MCI Phone' },
  { value : '@pagemci.com'              ,text : 'MCI - @pagemci.com' },
  { value : '@mymetropcs.com'           ,text : 'Metro PCS' },
  { value : '@clearlydigital.com'       ,text : 'Midwest Wireless' },
  { value : '@mobilecomm.net'           ,text : 'Mobilecomm' },
  { value : '@page.mobilfone.com'       ,text : 'Mobilfone' },
  { value : '@sms.netcom.no'            ,text : 'Netcom' },
  { value : '@messaging.nextel.com'     ,text : 'Nextel' },
  { value : '@pacbellpcs.net'           ,text : 'Pacific Bell' },
  { value : '@email.swbw.com'           ,text : 'Southwestern Bell' },
  { value : '@messaging.sprintpcs.com'  ,text : 'Sprint' },
  { value : '@tmomail.net'              ,text : 'T-Mobile' },
  { value : '@union-tel.com'            ,text : 'Union Wireless' },
  { value : '@email.uscc.net'           ,text : 'US Cellular' },
  { value : '@uswestdatamail.com'       ,text : 'US West' },
  { value : '@vtext.com'                ,text : 'Verizon' },
  { value : '@vmobl.com'                ,text : 'Virgin Mobile' },
  { value : '@viaerosms.com'            ,text : 'Viaero' },
  { value : '@pagemart.net'             ,text : 'WebLink Wireless' },
  { value : '@sms.wcc.net'              ,text : 'West Central Wireless' },
  { value : '@cellularonewest.com'      ,text : 'Western Wireless' },
  { value : '@cellcom.quiktxt.com'      ,text : 'Cellcom' },
  { value : '@pcs.rogers.com'           ,text : 'Rogers' }
]

export const isEmptyVal = (val) => {
  const value = (typeof val === 'string') ?
    val.trim() : val
  return isNumber(value) ? (value <= 0) :
    ((isEmpty(value) && ![true, false].includes(value)) || isDate(value))
}

export const getTimeDiff = (startTime, endTime) => {
  const startMoment = moment(new Date(startTime),
    "YYYY-MM-DD HH:mm:ss GMT+0000");
  const endMoment = moment(new Date(endTime), "YYYY-MM-DD HH:mm:ss GMT+0000");
  const duration = moment.duration(endMoment.diff(startMoment));
  const hours = duration.asHours()
  return hours
}

export const getWeekMoments = (date, startDay = 0) => {
  const start = (date ? moment(date, MOMENT_FORMAT_DATE) : moment())
  if (parseInt(startDay) > start.day()) {
    start.subtract(1, 'week')
  }

  start.day(startDay)
  return {
    start : start.startOf('day'),
    end   : start.clone().add(6, 'days').endOf('day')
  }
}

export const getWeekIntervals = (interval, startDay) => {
  const weekIntervals = []
  let tempInterval = getWeekMoments(
    interval.start.format(MOMENT_FORMAT_DATE), startDay)
  while (!tempInterval.start.isAfter(interval.end)) {
    weekIntervals.push({
      start : tempInterval.start.clone().startOf('day'),
      end   : tempInterval.end.clone().endOf('day')
    })
    tempInterval = getWeekMoments(
      tempInterval.end
        .clone()
        .add(1, 'day')
        .startOf('day')
        .format(MOMENT_FORMAT_DATE),
      startDay
    )
  }
  return weekIntervals
}

export const getDatesBetween = function (startDate, endDate) {
  const dates = []

  const start = startDate.clone()

  while (!start.isAfter(endDate)) {
    dates.push(start.clone())

    start.add(1, 'day')
  }

  return dates
}


export const CISort = (array, key) => {
  if (key) {
    return array.sort((a, b) => {
      return (a[key].toLowerCase() > b[key].toLowerCase()) ? 1 :
        (a[key].toLowerCase() < b[key].toLowerCase()) ? -1 : 0
    })
  } else {
    return array.sort((a, b) => {
      return (a.toLowerCase() > b.toLowerCase()) ? 1 :
        (a.toLowerCase() < b.toLowerCase()) ? -1 : 0
    })
  }
}

const getError = (apiError, concatEl) => {
  let errorsObj = ''
  let errorArray = []
  if (isArray(apiError)) {
    errorArray = apiError
  }

  if (isArray(apiError.errors)) {
    errorArray = apiError.errors
  }

  concatEl = concatEl || '<br>'
  errorArray.forEach(err => {
    errorsObj += (isString(err) ? err : err.message) + concatEl
  })

  return errorsObj
}

export const concatErrorsFromApi = (apiError, concatEl) => {
  if (isEmpty(apiError)) {
    return ''
  }

  if (isString(apiError)) {
    return apiError
  }

  if (apiError.message && isEmpty(apiError.errors) &&
    !(apiError.response && apiError.response.data)) {
    return apiError.message
  }

  if (!isEmpty(apiError.errors)) {
    return getError(apiError, concatEl)
  }

  if (apiError.response && apiError.response.data) {
    if (apiError.response.data.message &&
      (!isArray(apiError.response.data) &&
        isEmpty(apiError.response.data.errors))) {
      return apiError.response.data.message
    }

    if (isArray(apiError.response.data) ||
      isArray(apiError.response.data.errors)) {
      return getError(apiError.response.data, concatEl)
    }

    return apiError.response.data
  }

  return ''
}

export const getTimeFromGQL = (start, end, format = TIME_FORMAT) => {
  return `${moment(start,GQL_DATE_FORMAT).format(format)}` +
    ` - ${end ? moment(end,GQL_DATE_FORMAT).format(format) : '-'}`
}

export const getDateFromGQL = (date, format = 'MMMM D, dddd') => {
  return moment(date, GQL_DATE_FORMAT).format(format)
}

export function jsDateToMomentDate (date, format = "ddd MMM DD YYYY hh:mm:ss GMT+0000") {
  return moment(date, format)
}

export const getTime = (request, isStart = true) => {
  if(request.actionType ||
     request['__typeName'] === 'Request' ){
    const date = isStart ? request.startDate : request.endDate
    const time = isStart ? request.startTime : request.endTime
    return  `${getDateFromGQL(date, 'DD-MMM-YYYY')} `+
      `${getDateFromGQL(time,'hh:mmA')}`
  } else if(request.type ||
     request['__typeName'] === 'WorkScheduleRequestType') {
    const date = request.schedule.date
    const time  = isStart ?
      request.schedule.startTime :request.schedule.endTime
    if(request.type === 'SWAP') {
      const swappedDate =  request.swappedSchedule.date
      const swappedTime =isStart ?
        request.swappedSchedule.startTime :
        request.swappedSchedule.endTime
      return  `${getDateFromGQL(date, 'DD-MMM-YYYY')} `+
            `${getDateFromGQL(time, 'hh:mmA')} \n`+
            `${getDateFromGQL(swappedDate, 'DD-MMM-YYYY')} `+
            `${getDateFromGQL(swappedTime, 'hh:mmA')}`
    } else {
      return  `${getDateFromGQL(date, 'DD-MMM-YYYY')} `+
        `${getDateFromGQL(time, 'hh:mmA')}`
    }
  }
}

export const SPRound = (value, decimals, force) => {
  decimals = decimals || 0
  const rounder = Math.pow(10, decimals)
  const v = decimals
    ? Math.round((value + 0.00001) * rounder) / rounder
    : Math.round(value)

  if(decimals && force) {
    return v.toFixed(decimals)
  }

  return v
}

export const currentDate = () => moment().format(MOMENT_FORMAT_DATE)

export default getTime

export const ucFirst = str => upperFirst(toLower(str))


export const round = (value, decimals) => {
  decimals = decimals || 0
  const rounder = Math.pow(10, decimals)
  return decimals
    ? Math.round((value + 0.00001) * rounder) / rounder
    : Math.round(value)
}

export const numberLocaleString = (x, d=0) => SPRound(parseFloat(x || 0), d, true).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const parseGenericDate = (dateSting, year)  => {
  let date = year ? moment().year(year) : moment()
  const ds = dateSting.split('/')

  if (ds.length > 2) {
    date.year(parseInt(ds[2]))
  }

  date.month((parseInt(ds[0]) - 1))
  
  if (ds[1].charAt(0) === '(') {
    const w = ds[1].slice(1, -1).split(',')
    const wd = parseInt(w[0])
    const dt = parseInt(w[1])
    const d = moment(date).startOf('month')
    const limit = (moment(date).endOf('month').diff(d, 'days') + 1)
    const wds = []

    for (let ai = 0; ai < limit; ai++) {
      if (d.day() === wd) {
        wds.push(moment(d))
      }
      d.add(1, 'day')
    }

    if (dt < 0) {
      date = wds[wds.length + dt]
    } else {
      date = wds[dt - 1]
    }
  } else {
    date.date(ds[1])
  }

  if (!moment.isMoment(date)) {
    return false
  }

  date = date.startOf('day')
  
  return date
}
